<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-search`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.7707798,45.2127271 C10.7707798,26.1169249 26.4424174,10.6380412 45.7762085,10.6380412 C65.1099995,10.6380412 80.7816371,26.1169249 80.7816371,45.2127271 C80.7816371,64.3085292 65.1099995,79.7872571 45.7762085,79.7872571 C26.4424174,79.7872571 10.7707798,64.3085292 10.7707798,45.2127271 Z M45.7762085,0 C20.494396,0 0,20.2419648 0,45.2127271 C0,70.1833335 20.494396,90.4252983 45.7762085,90.4252983 C56.1326668,90.4252983 65.6838332,87.0291973 73.3525665,81.3029033 L100.384753,108 L108,100.478493 L81.1262213,73.9361396 C87.8803235,65.8522256 91.5677212,55.6936871 91.5524169,45.2127271 C91.5524169,20.2419648 71.0580209,0 45.7762085,0 Z" transform="translate(13 11)" :fill="useCurrentColor ? 'currentColor' : '#1D2129'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmSearch',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
